import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { LogOut, Moon, Search as SearchIcon, Settings as SettingsIcon, Sun } from 'lucide-react'
import { useAuth } from '../stores/auth'
import { useTheme } from '../stores/theme'
import { cn } from '../lib/cn'

const navItems = [
  { to: '/', label: 'Search', icon: SearchIcon },
  { to: '/settings', label: 'Settings', icon: SettingsIcon },
]

export function Layout() {
  const { user, logout } = useAuth()
  const { theme, toggle: toggleTheme } = useTheme()
  const nav = useNavigate()

  return (
    <div className="min-h-screen flex">
      <aside className="w-56 shrink-0 border-r border-border bg-surface/40 flex flex-col">
        <div className="px-5 py-5 border-b border-border">
          <Link to="/" className="block">
            <div className="text-sm font-semibold text-gray-100">Sales Navigator</div>
            <div className="text-xs text-gray-500 mt-0.5">Personal · Beta</div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition',
                  isActive
                    ? 'bg-muted text-gray-100'
                    : 'text-gray-400 hover:bg-muted/40 hover:text-gray-200',
                )
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 text-xs text-gray-500">
            Logged in as <span className="text-gray-300">{user?.username}</span>
          </div>
          <button
            className="btn-ghost w-full justify-start gap-2.5 mt-1"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
            {theme === 'dark' ? 'Light mode' : 'Dark mode'}
          </button>
          <button
            className="btn-ghost w-full justify-start gap-2.5 mt-1"
            onClick={async () => {
              await logout()
              nav('/login', { replace: true })
            }}
          >
            <LogOut size={16} />
            Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
